import { render, staticRenderFns } from "./ReSearchObjGrouping.vue?vue&type=template&id=1123b8a2&scoped=true"
import script from "./ReSearchObjGrouping.vue?vue&type=script&lang=js"
export * from "./ReSearchObjGrouping.vue?vue&type=script&lang=js"
import style0 from "./ReSearchObjGrouping.vue?vue&type=style&index=0&id=1123b8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1123b8a2",
  null
  
)

export default component.exports